import { DataWidgetHeaderType, DataWidgetType, DataWidgetSentiment, DataWidgetIcon, DataWidgetDataType, SaleTypeFilter, SaleStatusFilter } from "app/utility/enums";
import { ChartDataset, ChartOptions } from "chart.js";
import { LookupInternalModel } from "../shared/lookup.model";

export class DataWidgetResultModel {
    public headerDisplay: string;
    public headerDisplayType: DataWidgetHeaderType;
    public dataWidgetType: DataWidgetType;

    public dataItemErrorMessage: string;

    public dataItemSimple: DataWidgetItemSimpleWrapModel;
    public dataItemList: DTODataWidgetItemListWrapModel;
    public dataItemSimpleGroup: DTODataWidgetItemSimpleGroupWrapModel;
}

export class DataWidgetItemSimpleWrapModel {
    public primary: DataWidgetItemSimpleModel;
    public secondary: DataWidgetItemSimpleModel;
    public tertiary: DataWidgetItemSimpleModel;

    public otherItems: DataWidgetItemSimpleModel[];
}

export class DataWidgetItemSimpleModel {
    public value: number;
    public valueDisplay: string;
    public textDisplay: string;

    public sentiment: DataWidgetSentiment;
    public iconType: DataWidgetIcon;
}

export class DTODataWidgetItemListWrapModel {
    groups: DTODataWidgetListItemGroupModel[] = [];
}

export class DTODataWidgetListItemGroupModel {
    groupId: string;
    groupName: string;
    items: DTODataWidgetListItemModel[] = [];

    chartDatasource: ChartDataset[] = [];
    chartLabels: string[] = [];
    chartOptions: ChartOptions<'doughnut'>;
}

export class DTODataWidgetListItemModel {
    value: number;
    valueDisplay: string;
    textDisplay: string;
    textDisplayDetail: string;
    ids: string[];
}

export class DTODataWidgetItemSimpleGroupWrapModel {
    groups: DataWidgetSimpleGroupModel[] = [];
}
export class DataWidgetSimpleGroupModel {
    groupId: string;
    groupName: string;
    item: DataWidgetItemSimpleWrapModel;
}

export class DTODataWidgetFiltersListModel {
    salesFilters: DTODataWidgetSalesFilters = new DTODataWidgetSalesFilters();
    salesBreakdownFilters: DTODataWidgetSalesBreakdownFilters = new DTODataWidgetSalesBreakdownFilters();   
}

export class DTODataWidgetFiltersModel {
    filters: DTODataWidgetFiltersListModel = new DTODataWidgetFiltersListModel();
    widgetDataType: DataWidgetDataType;
    dealershipId: string;
    dateFrom: Date;
    dateTo: Date;
}

export class DTODataWidgetSalesFilters
{
    saleType: SaleTypeFilter = SaleTypeFilter.All;
    saleStatus: SaleStatusFilter = SaleStatusFilter.IncludeAll;
}

export class DTODataWidgetSalesBreakdownFilters
{
    saleType: SaleTypeFilter = SaleTypeFilter.All;
    saleStatus: SaleStatusFilter = SaleStatusFilter.IncludeAll;
}
